import { styled } from "@mui/material/styles";
import Stepper from "@mui/material/Stepper";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import { ReactComponet as CompleteIcon } from "assets/images/icons/completeStep.svg";
export const CustomStepper = styled(Stepper)(({ theme }) => ({
  background: "white",
  boxShadow: "none",
}));

export const CustomStepLabel = styled(StepLabel)(({ theme, ownerState }) => {
  const { palette } = theme;
  const { color } = ownerState;
  return {
    "& .MuiStepLabel-label": {
      "&.Mui-active": {
        color: `${palette[color].main} !important`,
      },
      "&.Mui-completed": {
        color: `${palette[color].main} !important`,
        fontWeight: "bold !important",
      },
      "&.Mui-disabled": {
        color: `#b2bec3 !important`,
      },
    },
  };
});
export const QontoConnector = styled(StepConnector)(({ theme, ownerState }) => {
  const { palette } = theme;
  const { color } = ownerState;
  return {
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: "calc(-50% + 16px)",
      right: "calc(50% + 16px)",
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: palette[color].main,
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: palette[color].main,
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : "#b2bec3",
      borderTopWidth: 3,
      borderRadius: 1,
    },
  };
});

export const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => {
  const { palette } = theme;
  const { color } = ownerState;
  return {
    color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#b2bec3",
    display: "flex",
    cursor:'pointer',
    height: 22,
    flexDirection: "row",
    alignItems: "center",
    ...(ownerState.active && {
      color: palette[color].main,
    }),
    "& .QontoStepIcon-completedIcon": {
      width: "24px",
      height: "24px",
      margin: "0 0 0 9px",
      padding: " 4px",
      boxShadow: "3px 3px 5px 0 rgba(0, 0, 0, 0.1)",
      backgroundColor: "#abaee7",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: " center",
    },
    "& .QontoStepIcon-completedIcon-inner": {
      width: "20px",
      height: "20px",
      padding: "0 8px 0 9px",
      boxShadow: " 2px 2px 5px 0 rgba(0, 0, 0, 0.3)",
      border: "solid 2px #6610f2",
      backgroundColor: "#6610f2",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: " center",
      paddingTop:'3px'
    },
    "& .QontoStepIcon-Icon": {
      width: "24px",
      height: " 24px",
      margin: "0 0 0 9px",
      padding: " 4px",
      boxShadow: "3px 3px 5px 0 rgba(0, 0, 0, 0.1)",
      backgroundColor: "#ebf0fb",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: " center",
      textAlign:'center',
      verticalAlign: "middle"
    },
    "& .QontoStepIcon-Icon-inner": {
      width: "20px",
      height: "20px",
      padding: "0 8px 0 9px",
      boxShadow: " 2px 2px 5px 0 rgba(0, 0, 0, 0.3)",
      border: "solid 2px #9899aa",
      backgroundColor: "#9899aa",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: " center",
      textAlign:'center',
      verticalAlign: "middle",
      paddingTop:'3px'
    },
  };
});
